<template>
  <div class="creator flex align-center">
    <AvatarsBlock
      :people="commonCreators"
      size="26"/>
    <div class="ml-1">
      <PersonTooltip
        v-for="(person, n) in commonCreators.slice(-2)"
        :key="n"
        :avatar="person && person.avatar"
        class="mr-1"
        :department="person ? person.department : {}"
        :name="person ? person.fullName || person.userId.trim() : ''"/>
      <span v-if="commonCreators.length > 2">{{ $t('Purchasing.More') }} +  {{ commonCreators.length - 2 }}</span>
    </div>
  </div>
</template>
<script>
import AvatarsBlock from 'components/common/elements/AvatarsBlock.vue'
import PersonTooltip from 'components/common/blocks/PersonTooltip.vue'

export default {
  name: 'creatorsTooltip',
  props: {
    commonCreators: [Object, Array],
    creatorsData: [Object, Array]
  },
  components: {
    AvatarsBlock,
    PersonTooltip
  }
}
</script>
<style lang="scss" scoped>
.creator {

  .icons {
    &:nth-child(2) {
      right: 10px;
    }
    &:nth-child(3) {
      right: 20px;
    }
    position: relative;
  }
}
.tooltip-item {
  display: flex;

  .fullName {
    display: flex;
    align-items: center;
    padding: 10px 0;
  }
}
</style>
